// src/pages/brand-collaborations-client-stories/index.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';

import CollaborationHero from './components/CollaborationHero';
import InteractiveTimeline from './components/InteractiveTimeline';
import FeaturedPartnerships from './components/FeaturedPartnerships';
import ClientTestimonials from './components/ClientTestimonials';
import IndustryVerticals from './components/IndustryVerticals';
import CaseStudyShowcase from './components/CaseStudyShowcase';
import BehindTheScenes from './components/BehindTheScenes';
import PartnershipEvolution from './components/PartnershipEvolution';
import CollaborationGallery from './components/CollaborationGallery';
import CollaborationCTA from './components/CollaborationCTA';

const BrandCollaborationsClientStories = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [isScrolled, setIsScrolled] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState('technology');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const collaborationCategories = [
    {
      id: 'all',
      name: 'All Stories',
      icon: 'Globe',
      count: '150+'
    },
    {
      id: 'fortune500',
      name: 'Fortune 500',
      icon: 'Building2',
      count: '50+'
    },
    {
      id: 'luxury-real-estate',
      name: 'Luxury Real Estate',
      icon: 'Home',
      count: '75+'
    },
    {
      id: 'high-profile-events',
      name: 'High-Profile Events',
      icon: 'Calendar',
      count: '100+'
    },
    {
      id: 'repeat-clients',
      name: 'Repeat Collaborations',
      icon: 'Repeat',
      count: '85%'
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      {/* Collaboration Hero Section */}
      <CollaborationHero />

      {/* Navigation Filter */}
      <div className={`sticky top-20 z-40 bg-white/95 backdrop-blur-md border-b border-border transition-all duration-300 ${isScrolled ? 'shadow-subtle' : ''}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center space-x-6 overflow-x-auto">
              {collaborationCategories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setActiveFilter(category.id)}
                  className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium text-sm whitespace-nowrap transition-all duration-300 ${
                    activeFilter === category.id
                      ? 'bg-accent text-white shadow-glow'
                      : 'text-text-secondary hover:text-accent hover:bg-surface'
                  }`}
                >
                  <Icon name={category.icon} size={16} strokeWidth={2} />
                  <span>{category.name}</span>
                  <span className="text-xs bg-black/10 px-2 py-0.5 rounded-full">{category.count}</span>
                </button>
              ))}
            </div>
            <Link
              to="/booking-concierge-premium-consultation"
              className="hidden md:flex items-center space-x-2 bg-primary text-white px-6 py-2 rounded-lg font-semibold text-sm hover:bg-primary-dark cinematic-transition"
            >
              <Icon name="MessageSquare" size={16} strokeWidth={2} />
              <span>Start Your Story</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Interactive Timeline */}
      <InteractiveTimeline />

      {/* Featured Partnerships */}
      <FeaturedPartnerships activeFilter={activeFilter} />

      {/* Client Testimonials */}
      <ClientTestimonials />

      {/* Industry Verticals */}
      <IndustryVerticals 
        selectedIndustry={selectedIndustry} 
        setSelectedIndustry={setSelectedIndustry} 
      />

      {/* Case Study Showcase */}
      <CaseStudyShowcase />

      {/* Behind The Scenes */}
      <BehindTheScenes />

      {/* Partnership Evolution */}
      <PartnershipEvolution />

      {/* Collaboration Gallery */}
      <CollaborationGallery />

      {/* Call to Action */}
      <CollaborationCTA />
    </div>
  );
};

export default BrandCollaborationsClientStories;